module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "添加活动"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "createActivityForm",
    staticClass: "form",
    attrs: {
      "rules": _vm.activityRules,
      "model": _vm.createActivityParams
    }
  }, [_c('Row', [_c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "活动名称：",
      "prop": "name"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入活动名称用于列表展示"
    },
    model: {
      value: (_vm.createActivityParams.name),
      callback: function($$v) {
        _vm.$set(_vm.createActivityParams, "name", $$v)
      },
      expression: "createActivityParams.name"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "活动分类：",
      "prop": "activityType"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.createActivityParams.activityType),
      callback: function($$v) {
        _vm.$set(_vm.createActivityParams, "activityType", $$v)
      },
      expression: "createActivityParams.activityType"
    }
  }, _vm._l((_vm.$constant.activityType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "活动时间：",
      "prop": "activityTime"
    }
  }, [_c('DatePicker', {
    attrs: {
      "format": "yyyy-MM-dd",
      "type": "daterange",
      "placement": "bottom-start",
      "placeholder": "选择起始时间"
    },
    on: {
      "on-change": _vm.timeDateChange
    },
    model: {
      value: (_vm.time),
      callback: function($$v) {
        _vm.time = $$v
      },
      expression: "time"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "活动标识：",
      "prop": "tag"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入活动标识"
    },
    model: {
      value: (_vm.createActivityParams.tag),
      callback: function($$v) {
        _vm.$set(_vm.createActivityParams, "tag", $$v)
      },
      expression: "createActivityParams.tag"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "活动状态：",
      "prop": "status"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.createActivityParams.status),
      callback: function($$v) {
        _vm.$set(_vm.createActivityParams, "status", $$v)
      },
      expression: "createActivityParams.status"
    }
  }, [_c('Option', {
    key: "1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('Option', {
    key: "2",
    attrs: {
      "value": "0"
    }
  }, [_vm._v("禁用")])], 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "活动说明："
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 5
      },
      "placeholder": "请输入活动描述"
    },
    model: {
      value: (_vm.createActivityParams.description),
      callback: function($$v) {
        _vm.$set(_vm.createActivityParams, "description", $$v)
      },
      expression: "createActivityParams.description"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAddActivity
    },
    on: {
      "click": _vm.createActivity
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6acebf10","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/market/modal/CreateActivityModal.vue
// module id = 1870
// module chunks = 8